module.exports = {
  OPEN: 'OPEN',
  WAITING_RESOLUTION: 'WAITING_RESOLUTION',
  CONFIRMED: 'CONFIRMED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED'
};
